import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A single-line input. `variant` picks the geometry class: "date" (the default, `date-input`),
 * "search" (`text-search`) and — walk 4 review fix (PR #2273) — "text" (`ds-input`, a plain form
 * field, styled by `@ardept/design-system/styles/components.css`). Earlier callers are unchanged.
 */
export function Input({ className = "", variant, ...rest }) {
    const baseClass = variant === "search" ? "text-search" : variant === "text" ? "ds-input" : "date-input";
    return _jsx("input", { className: `${baseClass} ${className}`.trim(), ...rest });
}
/**
 * A native select with the kit's form-field look (`ds-input ds-select`). Walk 4 review fix
 * (PR #2273): the look-through dialog's band and "how did you confirm this" choices. The options
 * are data (`value` + `label`), so a caller never hand-builds the markup.
 */
export function Select({ className = "", options, value, onValueChange, ...rest }) {
    return (_jsx("select", { className: `ds-input ds-select ${className}`.trim(), value: value, onChange: (event) => onValueChange(event.target.value), ...rest, children: options.map((option) => (_jsx("option", { value: option.value, children: option.label }, option.value))) }));
}
export function Textarea({ className = "", ...rest }) {
    return _jsx("textarea", { className: `ta ${className}`.trim(), ...rest });
}
//# sourceMappingURL=Input.js.map